"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkipPopup = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const Popup_1 = require("./Popup");
const pixi_js_1 = require("pixi.js");
const blocks_1 = require("../blocks");
const Global_1 = require("../Global");
const i18next_1 = __importDefault(require("i18next"));
const next_svg_1 = __importDefault(require("../../assets/svg/next.svg"));
const MenuButton_1 = require("../blocks/MenuButton");
const settings_1 = require("../config/settings");
const BrushScore_1 = require("../blocks/BrushScore");
const AssetManager_1 = __importDefault(require("../managers/AssetManager"));
const config_json_1 = __importDefault(require("../../../shared/config.json"));
const IconButton_1 = require("../blocks/IconButton");
const WigglyText_1 = require("../objects/WigglyText");
const interfaces_1 = require("../../../shared/interfaces");
class SkipPopup extends Popup_1.Popup {
    constructor(app, gameManager) {
        super(app, true);
        this.gameManager = gameManager;
        this.filter = new pixi_js_1.AlphaFilter(0.75);
        this.info1 = this.makeInfo(i18next_1.default.t('levels.skipb'));
        this.icon = this.makeIcon();
        this.back = this.makeButton(i18next_1.default.t('levels.cancel'));
        this.score = this.background.addChild(new BrushScore_1.BrushScore(app));
        this.score.set(this.gameManager.playerManager.brushes);
        this.score.scale.set(1.2);
        this.brush = this.makeBrushButton();
        if ((0, Global_1.isPoki)()) {
            this.info2 = this.makeInfo(i18next_1.default.t('levels.skipv'));
            this.ad = this.makeAdButton();
        }
        this.layout();
    }
    close() {
        this.destroy({ children: true });
    }
    makeButton(txt) {
        const btn = new MenuButton_1.MenuButton(this.app, txt, settings_1.Settings.negativeColor, this.overSmallSize ? 120 : 100, this.overSmallSize ? 60 : 50, 8, 4, this.overSmallSize ? 40 : 32);
        const button = btn.asButton();
        this.sigs.push(button.onPress.connect(() => {
            AssetManager_1.default.tickSound();
            this.close();
        }));
        return this.background.addChild(button);
    }
    destroy(_options) {
        super.destroy(_options);
        this.filter.destroy();
    }
    makeBrushButton() {
        const canbuy = this.gameManager.playerManager.brushes >= config_json_1.default.skipcost;
        const sprite = pixi_js_1.Sprite.from(AssetManager_1.default.brushpoint);
        sprite.scale.set((0, Global_1.px)(0.25));
        const text = new WigglyText_1.WigglyText(this.app, config_json_1.default.skipcost.toString(), blocks_1.Block.textStyle(38, false));
        const btn = new IconButton_1.IconButton(this.app, text, sprite);
        btn.color = canbuy ? settings_1.Settings.positiveColor : settings_1.Settings.lightGrayColor;
        btn.size = { width: this.overSmallSize ? 100 : 90, height: this.overSmallSize ? 60 : 50 };
        const button = btn.asButton(0.01);
        if (!canbuy) {
            button.enabled = false;
            button.filters = [this.filter];
        }
        this.sigs.push(button.onPress.connect(() => {
            if (this.didskip) {
                AssetManager_1.default.tickSound();
                this.gameManager.playerManager.buy(interfaces_1.Store.Skip);
                this.didskip();
            }
        }));
        return this.background.addChild(button);
    }
    makeAdButton() {
        const txt = '🎬';
        const btn = new MenuButton_1.MenuButton(this.app, txt, settings_1.Settings.positiveColor, this.overSmallSize ? 100 : 90, this.overSmallSize ? 60 : 50, 8, 4, 40);
        const button = btn.asButton(0.01);
        button.pivot.set(button.width / 2, button.height / 2);
        this.sigs.push(button.onPress.connect(() => __awaiter(this, void 0, void 0, function* () {
            if (this.didskip) {
                AssetManager_1.default.tickSound();
                this.gameManager.stopPlay();
                if (yield this.gameManager.adManager.triggerReward(null)) {
                    this.gameManager.startPlay();
                    return this.didskip();
                }
                else {
                    this.gameManager.startPlay();
                }
            }
            this.close();
        })));
        return this.background.addChild(button);
    }
    makeIcon() {
        const icon = pixi_js_1.Sprite.from(next_svg_1.default);
        icon.anchor.set(0.5);
        return this.background.addChild(icon);
    }
    makeInfo(txt) {
        const style = blocks_1.Block.textStyle(this.overSmallSize ? 28 : 25);
        style.align = 'right';
        const info = new pixi_js_1.Text(txt, style);
        info.anchor.set(1, 0.5);
        return this.background.addChild(info);
    }
    layout() {
        var _a, _b, _c;
        super.layout();
        const settings = this.backgroundsettings;
        const centerx = (0, Global_1.px)(settings.width / 2);
        this.info1.position.set(centerx, (0, Global_1.px)(settings.height / 2) - this.info1.height - (0, Global_1.px)(15));
        (_a = this.info2) === null || _a === void 0 ? void 0 : _a.position.set(centerx, (0, Global_1.px)(settings.height / 2) + this.info2.height + (0, Global_1.px)(15));
        this.icon.scale.set((0, Global_1.px)(this.overSmallSize ? 0.38 : 0.3));
        this.icon.position.set(centerx, (0, Global_1.px)(settings.height / 8));
        const h = (0, Global_1.px)(this.backgroundsettings.height);
        this.back.position.set(centerx - this.back.width / 2, h - this.back.height - (0, Global_1.px)(15));
        this.score.layout();
        this.score.position.set((0, Global_1.px)(settings.width) - this.score.width - (0, Global_1.px)(10), (0, Global_1.px)(40));
        this.brush.position.set(centerx + this.brush.width / 2 + (0, Global_1.px)(20), this.info1.y);
        (_b = this.ad) === null || _b === void 0 ? void 0 : _b.position.set(centerx + this.ad.width / 2 + (0, Global_1.px)(20), ((_c = this.info2) === null || _c === void 0 ? void 0 : _c.y) || 0);
        super.layout();
    }
}
exports.SkipPopup = SkipPopup;
